import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const removeGroups = async ({
	id,
	groupIds
}: {
	id: string;
	groupIds: (string | number)[];
}) => {
	await Promise.all(
		groupIds.map((groupId) =>
			cmsClient.delete<unknown>(`/users/groups/${groupId}/members/${id}/`)
		)
	);
};

const useRemoveGroups = () => {
	const queryClient = useQueryClient();

	const onSuccess = (
		_: unknown,
		variables: { id: string; groupIds: (string | number)[] }
	) => {
		toast.success(<CustomToast type="Success" message="Groups removed" />, {
			hideProgressBar: true
		});

		queryClient.invalidateQueries(["person-profile", variables.id]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(removeGroups, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useRemoveGroups;
